import {RouteRecordRaw} from "vue-router";

const Home: RouteRecordRaw[] = [{
    path: "home/search",
    name: "H5HomeSearch",
    component: () => import("@/page/h5/home/search/index.vue"),
}]

export default Home
